import { TermEntity } from 'Models/Entities';

/**
 * Sort terms by term order and group by study period
 * @param a
 * @param b
 */
export const sortTermsAndGroupByStudyPeriod = (
	a: TermEntity,
	b: TermEntity,
) => (
	// combine study period and term orders into single numeric value
	((a.studyPeriod.order * 1000) + a.order) - ((b.studyPeriod.order * 1000) + b.order)
);
